Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = withTracking;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _airbnbTracking = require('airbnb-tracking');

var _airbnbTracking2 = _interopRequireDefault(_airbnbTracking);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _getComponentName = require('airbnb-prop-types/build/helpers/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _logging_universal_component_action_v = require('airbnb-jitney-schemas/logging_universal_component_action_v2');

var _logging_universal_component_impression_v = require('airbnb-jitney-schemas/logging_universal_component_impression_v2');

var _logging_type_operation_v = require('airbnb-jitney-schemas/logging_type_operation_v1');

var _constants = require('./constants');

var _thriftStructType = require('./utils/propTypes/thriftStructType');

var _thriftStructType2 = _interopRequireDefault(_thriftStructType);

var _eventDataType = require('./utils/propTypes/eventDataType');

var _eventDataType2 = _interopRequireDefault(_eventDataType);

var _requiredBy = require('./utils/propTypes/requiredBy');

var _requiredBy2 = _interopRequireDefault(_requiredBy);

var _productUtils = require('./utils/productUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var flushEventQueueInProgress = false;
var REACT_NATIVE = (0, _productUtils.isReactNative)();

function flushEventQueueAfterTimeout() {
  if (flushEventQueueInProgress) return;
  flushEventQueueInProgress = true;
  setTimeout(function () {
    flushEventQueueInProgress = false;
    _airbnbTracking2['default'].getLogger().flushEventQueue();
  }, 50);
}

function flushEventQueueAfterIdle() {
  if (flushEventQueueInProgress) return;
  flushEventQueueInProgress = true;
  requestIdleCallback(function () {
    flushEventQueueInProgress = false;
    _airbnbTracking2['default'].getLogger().flushEventQueue();
  });
}

var operationFromMethod = {
  onClick: _logging_type_operation_v.Operation.Click,
  onChange: _logging_type_operation_v.Operation.Update,
  onPress: _logging_type_operation_v.Operation.Click,
  onFocus: _logging_type_operation_v.Operation.Focus,
  onBlur: _logging_type_operation_v.Operation.Blur,
  onBackPress: _logging_type_operation_v.Operation.Click,
  onNextPress: _logging_type_operation_v.Operation.Click,
  onLeftPress: _logging_type_operation_v.Operation.Click,
  onRightPress: _logging_type_operation_v.Operation.Click,
  onPressPrimary: _logging_type_operation_v.Operation.Click,
  onPressSecondary: _logging_type_operation_v.Operation.Click,
  onSaveChange: _logging_type_operation_v.Operation.Save,
  onPressActionText: _logging_type_operation_v.Operation.Click,
  onClose: _logging_type_operation_v.Operation.Dismiss,
  onCancel: _logging_type_operation_v.Operation.Dismiss,
  onDismiss: _logging_type_operation_v.Operation.Dismiss,
  onSelect: _logging_type_operation_v.Operation.Click,
  onSubmit: _logging_type_operation_v.Operation.Submit,
  onActionPress: _logging_type_operation_v.Operation.Click,
  onActionButtonPress: _logging_type_operation_v.Operation.Click,
  onRatingChange: _logging_type_operation_v.Operation.Update,
  onReportButtonPress: _logging_type_operation_v.Operation.Click,
  onWishlistButtonPress: _logging_type_operation_v.Operation.Click,
  onExpand: _logging_type_operation_v.Operation.Show,
  onToggleCollapse: _logging_type_operation_v.Operation.Toggle,
  onCollapseToggle: _logging_type_operation_v.Operation.Toggle,
  onPressTab: _logging_type_operation_v.Operation.Click,
  onOpen: _logging_type_operation_v.Operation.Show,
  onImageChange: _logging_type_operation_v.Operation.Scroll
};

function evaluateEventData(eventData, methodName) {
  if ((typeof eventData === 'undefined' ? 'undefined' : _typeof(eventData)) === 'object') {
    return eventData;
  }

  if (typeof eventData === 'function') {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    var evaluatedEventData = eventData.apply(undefined, [methodName].concat(args));
    if ((typeof evaluatedEventData === 'undefined' ? 'undefined' : _typeof(evaluatedEventData)) !== 'object') {
      if (process.env.NODE_ENV !== 'production') {
        console.error('withTracking: eventData function returned ' + String(evaluatedEventData) + ', but should have returned an object.');
      }
      return {};
    }
    return evaluatedEventData;
  }

  return {};
}

function withTracking(componentName, handlerNames, additionalPropTypes) {
  return function () {
    function withTrackingHOC(WrappedComponent) {
      var WithTracking = function (_React$Component) {
        _inherits(WithTracking, _React$Component);

        function WithTracking(props, context) {
          _classCallCheck(this, WithTracking);

          var _this = _possibleConstructorReturn(this, (WithTracking.__proto__ || Object.getPrototypeOf(WithTracking)).call(this, props, context));

          _this.logImpression = _this.logImpression.bind(_this);
          _this.logComponentAction = _this.logComponentAction.bind(_this);
          _this.wrapMethodsForFrameworkEvents = _this.wrapMethodsForFrameworkEvents.bind(_this);

          // eslint-disable-next-line react/prop-types
          if (_this.props.loggingID) {
            _this.wrappedMethods = _this.wrapMethodsForFrameworkEvents(handlerNames, _this.props);
          }

          _this.state = {
            eventDataContext: context[_constants.CHANNEL] ? context[_constants.CHANNEL].getState() : null
          };
          return _this;
        }

        _createClass(WithTracking, [{
          key: 'getChildContext',
          value: function () {
            function getChildContext() {
              var loggingID = this.props.loggingID;


              if (!loggingID) {
                return {};
              }

              var _context = this.context,
                  _context$ancestorLogg = _context.ancestorLoggingIDs,
                  ancestorLoggingIDs = _context$ancestorLogg === undefined ? [] : _context$ancestorLogg,
                  _context$ancestorUUID = _context.ancestorUUIDs,
                  ancestorUUIDs = _context$ancestorUUID === undefined ? [] : _context$ancestorUUID;


              return {
                ancestorLoggingIDs: [].concat(_toConsumableArray(ancestorLoggingIDs), [loggingID]),
                ancestorUUIDs: [].concat(_toConsumableArray(ancestorUUIDs), [this.uuid])
              };
            }

            return getChildContext;
          }()
        }, {
          key: 'componentDidMount',
          value: function () {
            function componentDidMount() {
              var _this2 = this;

              var _props = this.props,
                  loggingID = _props.loggingID,
                  shouldLogImpression = _props.shouldLogImpression;

              if (loggingID) {
                this.uuid = (0, _v2['default'])();
                if (shouldLogImpression) {
                  this.logImpression();
                }
              }

              if (this.context[_constants.CHANNEL]) {
                this.subscriptionId = this.context[_constants.CHANNEL].subscribe(function (eventDataContext) {
                  _this2.setState({ eventDataContext: eventDataContext });
                });
              }
            }

            return componentDidMount;
          }()
        }, {
          key: 'componentWillReceiveProps',
          value: function () {
            function componentWillReceiveProps(nextProps) {
              var _this3 = this;

              if (process.env.NODE_ENV !== 'production') {
                if (nextProps.loggingID !== this.props.loggingID) {
                  console.error('withTracking: The loggingID of a withTracking component has changed! This should never happen. Supply eventData to the component in order to provide additional context. (' + String(this.props.loggingID) + ' to ' + String(nextProps.loggingID) + ').');
                }
              }
              if (!nextProps.loggingID) {
                return;
              }

              var propsToWrap = handlerNames.filter(function (propName) {
                return _this3.props[propName] !== nextProps[propName];
              });

              if (process.env.NODE_ENV !== 'production') {
                propsToWrap.forEach(function (propName) {
                  if (String(_this3.props[propName]) === String(nextProps[propName])) {
                    console.error('withTracking: it appears you are passing identical but not referentially equal versions of a function handler to a withTracking component. The prop needs to remain referentially equivalent across render cycles to avoid it being repeatedly re-wrapped by withTracking. (component: ' + String(componentName) + ', loggingID: ' + String(_this3.props.loggingID) + ', prop: ' + String(propName) + ')');
                  }
                });
              }

              this.wrappedMethods = Object.assign({}, this.wrappedMethods, this.wrapMethodsForFrameworkEvents(propsToWrap, nextProps));
            }

            return componentWillReceiveProps;
          }()
        }, {
          key: 'componentDidUpdate',
          value: function () {
            function componentDidUpdate(prevProps) {
              var _props2 = this.props,
                  loggingID = _props2.loggingID,
                  shouldLogImpression = _props2.shouldLogImpression;

              if (loggingID && shouldLogImpression && !prevProps.shouldLogImpression) {
                this.logImpression();
              }
            }

            return componentDidUpdate;
          }()
        }, {
          key: 'componentWillUnmount',
          value: function () {
            function componentWillUnmount() {
              if (this.context[_constants.CHANNEL] && this.subscriptionId) {
                this.context[_constants.CHANNEL].unsubscribe(this.subscriptionId);
              }
            }

            return componentWillUnmount;
          }()
        }, {
          key: 'logImpression',
          value: function () {
            function logImpression() {
              var _props3 = this.props,
                  loggingID = _props3.loggingID,
                  eventData = _props3.eventData,
                  eventDataSchema = _props3.eventDataSchema;
              var _context2 = this.context,
                  _context2$ancestorLog = _context2.ancestorLoggingIDs,
                  ancestorLoggingIDs = _context2$ancestorLog === undefined ? [] : _context2$ancestorLog,
                  _context2$ancestorUUI = _context2.ancestorUUIDs,
                  ancestorUUIDs = _context2$ancestorUUI === undefined ? [] : _context2$ancestorUUI,
                  loggingPage = _context2.loggingPage;
              var eventDataContext = this.state.eventDataContext;


              var log = {
                schema: _logging_universal_component_impression_v.UniversalComponentImpressionEvent,
                event_data: {
                  uuid: this.uuid || '',
                  logging_id: loggingID,
                  ancestor_logging_ids: ancestorLoggingIDs,
                  ancestor_uuids: ancestorUUIDs,
                  page: loggingPage,
                  event_data: Object.assign({}, eventDataSchema ? eventDataContext : {}, evaluateEventData(eventData, 'componentImpression')),
                  event_data_schema: eventDataSchema,
                  component: componentName
                }
              };

              if (REACT_NATIVE) {
                _airbnbTracking2['default'].logJitneyEvent(log);
              } else {
                _airbnbTracking2['default'].queueJitneyEvent(log);
                flushEventQueueAfterIdle();
              }
            }

            return logImpression;
          }()
        }, {
          key: 'logComponentAction',
          value: function () {
            function logComponentAction(methodName) {
              var _props4 = this.props,
                  loggingID = _props4.loggingID,
                  eventData = _props4.eventData,
                  eventDataSchema = _props4.eventDataSchema;
              var _context3 = this.context,
                  _context3$ancestorLog = _context3.ancestorLoggingIDs,
                  ancestorLoggingIDs = _context3$ancestorLog === undefined ? [] : _context3$ancestorLog,
                  _context3$ancestorUUI = _context3.ancestorUUIDs,
                  ancestorUUIDs = _context3$ancestorUUI === undefined ? [] : _context3$ancestorUUI,
                  loggingPage = _context3.loggingPage;
              var eventDataContext = this.state.eventDataContext;

              for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
              }

              var log = {
                schema: _logging_universal_component_action_v.UniversalComponentActionEvent,
                event_data: {
                  uuid: this.uuid || '',
                  logging_id: loggingID,
                  ancestor_logging_ids: ancestorLoggingIDs,
                  ancestor_uuids: ancestorUUIDs,
                  page: loggingPage,
                  event_data: Object.assign({}, eventDataSchema ? eventDataContext : {}, evaluateEventData.apply(undefined, [eventData, methodName].concat(args))),
                  event_data_schema: eventDataSchema,
                  operation: operationFromMethod[methodName],
                  method: methodName,
                  component: componentName
                }
              };

              if (REACT_NATIVE) {
                _airbnbTracking2['default'].logJitneyEvent(log);
              } else {
                _airbnbTracking2['default'].queueJitneyEvent(log);
                flushEventQueueAfterTimeout();
              }
            }

            return logComponentAction;
          }()
        }, {
          key: 'wrapMethodsForFrameworkEvents',
          value: function () {
            function wrapMethodsForFrameworkEvents(propsToWrap, nextProps) {
              var _this4 = this;

              var wrappedMethods = {};
              propsToWrap.forEach(function (propName) {
                var method = nextProps[propName];
                wrappedMethods[propName] = function () {
                  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                  }

                  _this4.logComponentAction.apply(_this4, [propName].concat(args));
                  if (method) {
                    return method.apply(undefined, args);
                  }
                  return undefined;
                };
              });
              return wrappedMethods;
            }

            return wrapMethodsForFrameworkEvents;
          }()
        }, {
          key: 'render',
          value: function () {
            function render() {
              var _props5 = this.props,
                  loggingID = _props5.loggingID,
                  eventData = _props5.eventData,
                  eventDataSchema = _props5.eventDataSchema,
                  shouldLogImpression = _props5.shouldLogImpression,
                  other = _objectWithoutProperties(_props5, ['loggingID', 'eventData', 'eventDataSchema', 'shouldLogImpression']);

              if (loggingID) {
                return _react2['default'].createElement(WrappedComponent, _extends({}, other, this.wrappedMethods));
              }
              return _react2['default'].createElement(WrappedComponent, other);
            }

            return render;
          }()
        }]);

        return WithTracking;
      }(_react2['default'].Component);

      WithTracking.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, WrappedComponent.propTypes, additionalPropTypes, {
        loggingID: _propTypes2['default'].string,
        eventData: _propTypes2['default'].oneOfType([_eventDataType2['default'], _propTypes2['default'].func]),
        eventDataSchema: (0, _requiredBy2['default'])('eventData', _thriftStructType2['default']),
        shouldLogImpression: _propTypes2['default'].bool
      }));

      WithTracking.contextTypes = _defineProperty({
        loggingPage: _propTypes2['default'].string,
        ancestorLoggingIDs: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
        ancestorUUIDs: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
      }, _constants.CHANNEL, _propTypes2['default'].object);

      WithTracking.childContextTypes = {
        ancestorLoggingIDs: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
        ancestorUUIDs: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
      };

      var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';

      WithTracking.WrappedComponent = WrappedComponent;
      WithTracking.defaultProps = WrappedComponent.defaultProps;
      WithTracking.displayName = 'withTracking(' + String(wrappedComponentName) + ')';

      return (0, _hoistNonReactStatics2['default'])(WithTracking, WrappedComponent);
    }

    return withTrackingHOC;
  }();
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-with-tracking/build/withTracking.js
// module id = 62
// module chunks = 168707334958949